import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { getKnowledgeBaseLink } from '../hublets/hubletSelectionUtils';
import { useHublets } from '../hublets/useHublets';
import MessagingCopy from '../messaging/MessagingCopy';
import { Data } from '../signup-data/DATA';
import { useTracker } from '../tracking/useTracker';
import { ButtonsGrid } from '../views-components/ButtonsGrid';
import { StyledUILink } from '../views-components/TextInput.styles';
import { Step } from '../views/Step';
const HelperText = styled(MessagingCopy).withConfig({
  displayName: "HubletOnePage__HelperText",
  componentId: "sc-1oumcu9-0"
})(["font-weight:400;font-size:16px;"]);
const TooltipWrapper = styled.div.withConfig({
  displayName: "HubletOnePage__TooltipWrapper",
  componentId: "sc-1oumcu9-1"
})(["", ""], props => props.isMobile && `padding: 10px 0; `);
export const HubletOnePage = () => {
  const {
    isUsingHubletRecommendation,
    hubletOptions
  } = useHublets();
  const dataKey = Data.HubletSelection;
  const stepKey = Step.HubletSelection;
  const defaultHelperText = `views.${stepKey}.helperText`;
  const tooltipLink = getKnowledgeBaseLink();
  const Tracker = useTracker();

  const getTooltipText = (isMobile = false) => {
    return /*#__PURE__*/_jsx(TooltipWrapper, {
      isMobile: isMobile,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `views.${stepKey}.tooltip`,
        options: {
          link: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: tooltipLink,
            onClick: event => {
              event.preventDefault();
              Tracker.signupInteraction('click-tooltip-link');
              window.open(tooltipLink, '_blank');
            },
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `views.${stepKey}.tooltipLink`
            })
          }, "title-link")
        }
      })
    });
  };

  return /*#__PURE__*/_jsx(UIFormControl, {
    help: isUsingHubletRecommendation && /*#__PURE__*/_jsx(HelperText, {
      message: defaultHelperText
    }),
    label: I18n.text(`views.${stepKey}.label`),
    tooltip: getTooltipText(),
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ButtonsGrid, {
        columnCount: 1,
        dataKey: dataKey,
        optionHeight: '48px',
        options: hubletOptions,
        shouldDisableAutofocus: true,
        stepKey: stepKey,
        type: 'radio'
      }, dataKey)
    })
  });
};